import { render, staticRenderFns } from "./YUserChoose.vue?vue&type=template&id=6575e856&scoped=true"
import script from "./YUserChoose.vue?vue&type=script&lang=js"
export * from "./YUserChoose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6575e856",
  null
  
)

export default component.exports